import {
  BirdviewCardError,
  BirdviewCardPlaceholder,
  BirdviewCardSkeleton,
} from '../../BirdviewCard'
import { BirdviewServiceRequestRow } from '../../BirdviewServiceRequestRow'
import { BirdviewState } from '../../DashboardBirdview.constants'

function getBirdviewAttentionRowItems({
  extra,
  items,
  requestActions,
  onOpenItem,
}) {
  return items.map(item => (
    <BirdviewServiceRequestRow
      extra={extra}
      item={item}
      key={item.id}
      requestActions={requestActions}
      onOpen={onOpenItem}
    />
  ))
}

export function getBirdviewAttentionRowBodyContent({
  emptyTextKey,
  extra,
  items,
  requestActions,
  state,
  t,
  onOpenItem,
  onRetry,
}) {
  switch (state) {
    case BirdviewState.Loading:
      return <BirdviewCardSkeleton />
    case BirdviewState.Empty:
      return (
        <BirdviewCardPlaceholder>{t(emptyTextKey)}</BirdviewCardPlaceholder>
      )
    case BirdviewState.Error:
      return <BirdviewCardError onRetry={onRetry} />
    case BirdviewState.Normal:
      return getBirdviewAttentionRowItems({
        extra,
        items,
        requestActions,
        onOpenItem,
      })
    default:
      return null
  }
}
